import login from "./login"

export default {
  login,
  api_messages: {
    project_access_denied: "Access denied",
    wrong_password: "Wrong password",
    email_not_verified: "You have not verified your email address yet, if you did'n receive the verification email, click here:"
  }
}